import {Component, input} from '@angular/core';

@Component({
  selector: 'app-icon-answer',
  imports: [],
  templateUrl: './icon-answer.component.html'
})
export class IconAnswerComponent {
  color = input('#4f4f4f');
}
